import { createSvgIcon } from '@material-ui/core/utils';

/** Thin chevron (lucide `chevron-down`, as used by the platform's shadcn Select) for MUI dropdowns. */
export const ChevronDownIcon = createSvgIcon(
  <path
    d="M6 9l6 6 6-6"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  'ChevronDown'
);
